export default {
	title: '404',
	text: 'Stránka nebyla nalezena',
};
